export default {
  UserPoolId: 'eu-west-1_XIwgzbz1O',
  ClientId: '25h02rm6t4khd8ljmlveihl81'
}
